module.exports = __webpack_public_path__ + "./fonts/montserrat-latin-600.15c24f7109941777774ddd2c636c6a50.woff2";